module.exports = __webpack_public_path__ + "img/installation-2.cd346278.png";